





































import {
  Component,
  Provide,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { WithDeviceType } from '@/mixins';

import AppFooter from '@/components/footer/Footer.vue';
import Logo from '@/components/header/Logo';
import AppHeader from '@/components/header/Header.vue';
import ScrollDirectionListener, {
  ScrollDirection,
} from '@/lib/scrollDirectionListener';

@Component({
  components: {
    AppFooter,
    AppHeader,
  },
})
export default class App extends mixins(WithDeviceType) {
  public readonly logo: Logo = {
    image: require('./assets/logo.svg'),
    alt: '雙喬嚴選',
  };

  // Initialize to false to show the navbar at the first paint.
  private hideFixedNavbar = false;
  private scrollDirectionListener?: ScrollDirectionListener;

  public beforeMount() {
    if (this.isMobile) {
      // Setup a ScrollDirectionListener to hide fixed navbar (either at the top or at the bottom)
      // on scrolling up.
      this.scrollDirectionListener = new ScrollDirectionListener((newDirection) => {
        if (newDirection === ScrollDirection.Up) {
          this.hideFixedNavbar = true;
        } else {
          this.hideFixedNavbar = false;
        }
      });
    }
  }

  public beforeDestroyed() {
    if (this.scrollDirectionListener) {
      this.scrollDirectionListener.destroy();
    }
  }

  @Provide()
  public get context() {
    const context = {};

    // Note that provide/inject bindings are NOT reactive unless we pass down an observed object.
    Object.defineProperties(context, {
      isMobile: {
        enumerable: true,
        get: () => this.isMobile,
      },
      hideFixedNavbar: {
        enumerable: true,
        get: () => this.hideFixedNavbar,
      },
    });
    return context;
  }
}

